import { useQuery } from "@apollo/client/react"; import React, { useEffect, useState, useMemo } from 'react';
import { Button, Grid } from '@mui/material';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const StepCuidadosDomiciliarios2 = ({
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI
}) => {
  const [cuidadosDomiciliarios, setCuidadosDomiciliarios] = useState(fullFormDataRI?.cuidadosDomiciliarios2 ?? {});
  const [combosRI, setCombosRI] = useState();

  const handleSubmit = () => {
    updateFormData('cuidadosDomiciliarios2', cuidadosDomiciliarios, validatedinputsGroups.flatMap((x) => x.inputs));
  };

  const handleChange = (name, value) => {
    setCuidadosDomiciliarios((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const getOptionsByName = (fieldName) => {
    const combos = {
      'idComboRIValorTabaquismo': combosRI?.idComboRIValorTabaquismo?.map((option) => { return { value: option.id, label: option.displayName }; })
    };

    return combos[fieldName] || [];
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);


  const validatedinputsGroups = useMemo(() => {
    const updatedRequired = inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((prevInput) => {
        const input = {
          ...prevInput,
          options: prevInput.type == 'select' || prevInput.type.includes('multiple') ? getOptionsByName(prevInput.name) : []
        };

        switch (input.name) {
          case 'tipoSustancia':
            return { ...input, required: cuidadosDomiciliarios.antecedenteConsumoSustancia };
          case 'drogasAInfundir':
            return { ...input, required: cuidadosDomiciliarios.infusionDrogas };
          case 'dosis':
            return { ...input, required: cuidadosDomiciliarios.infusionDrogas };
          case 'frecuencia':
            return { ...input, required: cuidadosDomiciliarios.infusionDrogas };
          case 'cumpleCriterioIngreso':
            return { ...input, required: cuidadosDomiciliarios.infusionDrogas };
          case 'cuantas':
            return { ...input, required: cuidadosDomiciliarios.infusionesPrevias };
          case 'donde':
            return { ...input, required: cuidadosDomiciliarios.infusionesPrevias };
          case 'reaccionesAdversas':
            return { ...input, required: cuidadosDomiciliarios.infusionesPrevias };
          default:
            return input;
        }
      })
    }));

    return updatedRequired;
  }, [
    selectedPrograms,
    cuidadosDomiciliarios.antecedenteConsumoSustancia,
    cuidadosDomiciliarios.infusionDrogas,
    cuidadosDomiciliarios.infusionesPrevias,
    combosRI]
  );

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [cuidadosDomiciliarios, setDataSubmissionCallback, validatedinputsGroups]);

  return (
    <div>
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.groupName}</label>
          <Grid container>
            {group.inputs.map((input) => {
              return (
                <RenderInputByTypeMobile
                  key={`${group.groupName}-${input.name}`}
                  grided
                  handleChange={handleChange}
                  input={input}
                  value={cuidadosDomiciliarios[input.name]} />);


            })}
          </Grid>
        </div>
      )}
    </div>);

};

export default StepCuidadosDomiciliarios2;

const inputsGroups = [
  {
    groupName: 'Hábitos',
    inputs: [
      {
        displayName: 'Tabaquismo',
        comboName: 'Tabaquismo',
        name: 'idComboRIValorTabaquismo',
        type: 'multiple_boolean',
        required: true,
        options: []
      },
      {
        displayName: 'Antecedentes de alcoholismo',
        name: 'antecedentesAlcoholismo',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Antecedentes de consumo de sustancias',
        name: 'antecedenteConsumoSustancia',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Tipo de sustancia',
        name: 'tipoSustancia',
        type: 'string',
        required: true
      }]

  },
  {
    groupName: 'Infusion de Drogas',
    inputs: [
      {
        displayName: 'Infusion de Drogas',
        name: 'infusionDrogas',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Droga a Infundir?',
        name: 'drogasAInfundir',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Dosis',
        name: 'dosis',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Frecuencia',
        name: 'frecuencia',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Cumple criterios de ingreso?',
        name: 'cumpleCriterioIngreso',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Realizo infusiones previas',
        name: 'infusionesPrevias',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Cuantas',
        name: 'cuantas',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Donde',
        name: 'donde',
        type: 'long_string',
        required: false
      },
      {
        displayName: 'Presento reacciones adversas',
        name: 'reaccionesAdversas',
        type: 'long_string',
        required: false
      }]

  }];